import React, { useEffect, useState } from "react";
import { Box, Typography, CircularProgress, Stack } from "@mui/material";
import { getAllInteractionLogsByAddress } from "api/Community/AddressesAPI";
import { UnifiedInteractionLog } from "api/Community/CommunityInterfaces";
import InteractionCard from "components/Interactions/InteractionCard";

interface AddressInteractionHistoryTabProps {
  addressId: number;
}

const AddressInteractionHistoryTab: React.FC<AddressInteractionHistoryTabProps> = ({
  addressId,
}) => {
  const [logs, setLogs] = useState<UnifiedInteractionLog[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!addressId) return;

    setLoading(true);
    setError(null);

    getAllInteractionLogsByAddress(addressId)
      .then((data) => setLogs(data))
      .catch((err) => {
        console.error("Error fetching interaction logs:", err);
        setError(err.message || "Failed to fetch interaction history.");
      })
      .finally(() => setLoading(false));
  }, [addressId]);

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Typography color="error" sx={{ mt: 2 }}>
        Error loading interaction history: {error}
      </Typography>
    );
  }

  if (!logs.length) {
    return (
      <Typography variant="body1" sx={{ mt: 2, color: "text.secondary" }}>
        No interaction history found for this address.
      </Typography>
    );
  }

  return (
    <Stack spacing={2}>
      {logs.map((log) => (
        <InteractionCard key={`${log.interaction_type}-${log.id}`} log={log} />
      ))}
    </Stack>
  );
};

export default AddressInteractionHistoryTab;
